import { render, staticRenderFns } from "./AddBankMovement.vue?vue&type=template&id=46f7af67&scoped=true&"
import script from "./AddBankMovement.vue?vue&type=script&lang=js&"
export * from "./AddBankMovement.vue?vue&type=script&lang=js&"
import style0 from "./AddBankMovement.vue?vue&type=style&index=0&id=46f7af67&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f7af67",
  null
  
)

export default component.exports